import https from "@/lib/https";
import type {
  CandidateListResponseData,
  GetCandidateListParams,
} from "@/interface/candidate";
import type { ApiResponse } from "@/interface/common";

const BASE_URL = "/api/master/profiles/";

export const getCandidateList = async (
  params?: GetCandidateListParams,
): Promise<ApiResponse<CandidateListResponseData>> => {
  return await https.get<ApiResponse<CandidateListResponseData>>(
    BASE_URL,
    params,
  );
};

export const deleteProfile = async (id: number | string): Promise<void> => {
  return await https.get<void>(`/delete-profile/${id}/`);
};

export const duplicateProfile = async (id: number | string): Promise<void> => {
  return await https.post<void>(`/api/profiles/${id}/duplicate/`, {});
};

